<script>
import {AxiosHelper} from '@src/utils/utils';

export default {
	components: { },
	props : {
	},
  data() {
    return {
			artist : '',
			title : '',

    }
	},
	created() {
	},
	mounted() {
	},
	methods : {
		show() {
			this.artist = '';
			this.title = '';

			this.$refs.modal.show();
		},

		regist() {
			if(this.artist === '' || this.title === '') {
				alert('가수와 노래를 입력해');
				return;
			}

			AxiosHelper.post(`/api/music/insert`, {
				artist : this.artist,
				title : this.title,
			}, (ret) => {
				this.$refs.modal.hide();
			});
		},


	}
}
</script>

<template>
	<C.Modal ref="modal" title='기타 노래 등록'
		dialog-class-name="modal-dialog-scrollable modal-md"
	>
		<template v-slot:buttons>
			<button type="button" class="btn btn-primary" @click="regist">등록</button>,
		</template>

		<div class="form-group row">
			<label class="col-4 col-form-label">가수
				</label>
			<div class="col-7">
				<input v-model="artist" type="text" class="form-control"/>
			</div>
		</div>

		<div class="form-group row">
			<label class="col-4 col-form-label">노래명</label>
			<div class="col-7">
				<input v-model="title" type="text" class="form-control"/>
			</div>
		</div>
	</C.Modal>

</template>